<template>
  <v-card dark v-if="application.profile">
    <v-card-title primary-title>
      <v-layout>
        <v-avatar class="elevation-2 mr-3" v-if="application.profile">
          <img :src="application.profile.avatar" />
        </v-avatar>
        <div>
          <div class="title">
            {{ application.profile.firstName }}
            {{ application.profile.lastName }}
          </div>
          <p class="subtitle" v-if="application.opportunity && application.opportunity.organization">
            {{ application.opportunity.organization.name }} - {{ application.opportunity.name }}
          </p>
        </div>
      </v-layout>
    </v-card-title>

    <v-divider />

    <!-- Attributes table -->
    <table class="v-table theme--dark">
      <tbody>
        <tr>
          <th class="text-xs-right">ID</th>
          <td>{{ application.id }}</td>
        </tr>

        <tr>
          <th class="text-xs-right">Status</th>
          <td>{{ application.status }}</td>
        </tr>

        <tr>
          <th class="text-xs-right">Profile</th>
          <td>
            <router-link
              :to="`/profiles/${application.profile.id}`"
            >
              {{ application.profile.firstName }} {{ application.profile.lastName }}
            </router-link>
          </td>
        </tr>

        <tr v-if="application.opportunity && application.opportunity.organization">
          <th class="text-xs-right">Organization</th>
          <td>
            <router-link :to="`/organizations/${application.opportunity.organization.id}`">
              {{ application.opportunity.organization.name }}
            </router-link>
          </td>
        </tr>

        <tr>
          <th class="text-xs-right">Opportunity</th>
          <td>
            <router-link
              :to="`/opportunities/${application.opportunity.id}`"
            >
              {{ application.opportunity.name }}
            </router-link>
          </td>
        </tr>

        <tr>
          <th class="text-xs-right">Applied</th>
          <td>
            {{ new Date(application.createdAt) | date("h:mm a, MMMM do yyyy") }}
            ({{ new Date(application.createdAt) | inWords({ addSuffix: true }) }})
          </td>
        </tr>

        <tr>
          <th class="text-xs-right">Locations</th>
          <td>
            <div v-for="l in application.locations" :key="l.id">
              {{ l.address }}
            </div>
          </td>
        </tr>

        <tr>
          <th class="text-xs-right">Last updated</th>
          <td>
            {{ new Date(application.updatedAt) | date("h:mm a, MMMM do yyyy") }}
            ({{ new Date(application.updatedAt) | inWords({ addSuffix: true }) }})
          </td>
        </tr>
      </tbody>
    </table>

    <v-divider />

    <v-card-actions>
      <can I="edit" :this="application">
        <v-dialog v-model="withdrawDialog" lazy max-width="600px" v-if="application.status !== 'Withdrawn'">
          <v-btn flat color="warning" slot="activator">
            Withdraw
          </v-btn>

          <v-card dark>
            <v-card-title>
              <div class="headline">Are you sure?</div>
            </v-card-title>
            <v-card-text>
              <v-select
                v-model="withdrawReason"
                label="Reason"
                :items="[
                  '',
                  'Applied for wrong opportunity',
                  'No longer interested',
                  'Other offer',
                  'Already have funding',
                  'Felt it was a poor fit',
                  'Rejected in the past',
                  'Commencement date passed',
                  'Other',
                ]"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn color="grey" flat block @click.native="withdrawDialog = false">cancel</v-btn>
              <v-btn color="warning" light block @click="withdraw">Withdraw</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </can>
      <v-spacer />
      <can I="delete" :this="application">
        <v-dialog v-model="dialog" lazy max-width="600px">
          <v-btn flat color="error" slot="activator">
            <v-icon left>mdi-delete</v-icon> Delete
          </v-btn>

          <v-card dark>
            <v-card-title class="headline">Delete application</v-card-title>
            <v-card-text>
              This action cannot be undone and will remove all associated data
              such as application history. It is not recommended for applications
              that were initiated by candidates.
            </v-card-text>
            <v-card-actions><v-spacer />
              <v-btn color="grey" flat @click.native="dialog = false">cancel</v-btn>
              <v-btn color="error" @click="destroy">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </can>
    </v-card-actions>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  props: {
    application: Object
  },
  data() {
    return {
      dialog: false,
      withdrawDialog: false,
      withdrawReason: '',
    }
  },
  methods: {
    withdraw() {
      this.withdrawDialog = false
      this.$emit('withdraw', this.withdrawReason)
      this.withdrawReason = ''
    },
    destroy() {
      this.$emit('destroy')
    },
  }
}
</script>
